// extracted by mini-css-extract-plugin
export default {"root":"AcquisitionInfoForm_root__6bAwD","actions":"AcquisitionInfoForm_actions__3m8V+","inputFieldWrapper":"AcquisitionInfoForm_inputFieldWrapper__KemgV"};